import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxToolbarActionResolver} from "../../dx-lists/domain/list/dx-toolbar-action-resolver";
import {DxListToolbarAction} from "../../dx-lists/domain/ui-options/list/toolbar/dx-list-toolbar-action";
import {DxTaskListItemDataProvider} from "../../dx-lists/domain/task-list/dx-task-list-item-data-provider";
import {DxDateTime} from "../../dx-core/utiles/dx-core-datetime-utils";
import {PitAgreementTaskResult} from "./pit-agreement-task-result";
import {PitBpmProcessInstance} from "../../pit-shared/domain/pit-bpm-process-instance";


/**
 * Задача в модуле "Согласование"
 * Может быть заполнена полностью или частично
 **/
@jsonObject()
export class PitAgreementTask implements DxTaskListItemDataProvider, DxToolbarActionResolver {

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: true})
  id: number;

  @jsonMember({constructor: PitBpmProcessInstance, emitDefaultValue: false, isRequired: true})
  processInstance: PitBpmProcessInstance;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true})
  name: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true})
  code: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  assigneeEmail: string;

  /**
   * Логин пользователя, являющегося исполнителем по задаче.
   */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: true})
  assigneeId: number;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true})
  assigneeLogin: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true})
  assigneeName: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  assigneePosition: string;

  /**
   * Заголовок для url, ведущей на контент задачи (как правило имя бизнесс-сущности по которой создан экземпляр задачи).
   */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true})
  contentCaption: string;

  /**
   * Url на карточку html-страницу или любую другую форму визуального представления контента (как правило содержимого бизнесс-сущности).
   */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true})
  contentUrl: string;

  /**
   * Описание задачи (из темплейта)
   */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  description: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  resultCompletedCaption: string;

  /**
   * Описание задачи (из инстанса)
   */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  comment: string;

  @jsonMember({constructor: Date, emitDefaultValue: false, isRequired: true})
  startDateTime: Date;

  @jsonMember({constructor: Date, emitDefaultValue: false, isRequired: true})
  planningFinishDateTime: Date;

  @jsonMember({constructor: Date, emitDefaultValue: false, isRequired: false})
  finishDateTime: Date;

  /**
   * Список позможных вариантов завершения экземпляра задачи.
   */
  @jsonArrayMember(PitAgreementTaskResult, {emitDefaultValue: false, isRequired: false})
  possibleResults: PitAgreementTaskResult[] = [];

  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: true})
  isActive: boolean;

  public getItemDescription(): string {
    return "";
  }

  public getItemIcon(): string {
    return "";
  }

  public getItemId(): number {
    return this.id;
  }

  public getItemIdent(): string {
    return this.code;
  }

  public getItemOrd(): number {
    return 0;
  }

  public getItemSearchString(): string {
    const str = this.getItemTitle() + ' ' +
                this.getTaskText() + ' ' +
                this.getPlannedEndDate();
    return str.toLocaleLowerCase();
  }

  public getItemTitle(): string {
    return this.code+ ' ' + this.name;
  }

  public canExecuteToolbarAction(action: DxListToolbarAction): boolean {
    return false;
  }

  public getAssignee(): string {
    return "";
  }

  public getSupervisor(): string {
    return "";
  }

  public getStatus(): string {
    return "";
  }

  public getStartDate(): string {
    return null;
  }

  public getEndDate(): string {
    return null;
  }

  public getTaskText(): string {
    return this.contentCaption;
  }

  getPlannedEndDate(): string {
    return DxDateTime.dateTimeToStr(this.planningFinishDateTime, DxDateTime.dateTimeFormats.datetime);
  }
}
